import React, {useEffect, useState} from "react";
import {
    Typography,
    Grid,
    makeStyles,
    Container,
    Card, TextField
} from "@material-ui/core";
import { ReactComponent as PetPaw } from "../../Images/petPaw.svg";
import {useHistory } from "react-router-dom";
import PaymentForm from "../../Components/PaymentForm";
import {colorError} from "../../Constants/theme";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {api_getEmployers} from "../../redux/common/common.api";

const useStyle = makeStyles(() => ({
    cardRoot: {
        width: "100%",
        padding: 40,
        marginBottom: 32,
    },
    containerRoot: {
        paddingTop: 100,
        marginBottom: 55,
        zIndex: 1,
    },
    body: {
        paddingTop: 20,
    },
    spacing: {
        paddingTop: 20,
    },
    spacingImage: {
        paddingTop: 20,
        display: "flex"
    },
}));

interface Props {
    title: string;
    details: string | React.ReactNode;
}

const PawCard = ({title, details} : Props) => {
    return (
        <Grid container item xs={12} justify="center" alignContent="center" style={{paddingBottom: 10}}>
            <Grid item xs={2} alignItems="center">
                <PetPaw style={{height: "100%", width: 40, display: "block", margin: "0 auto"}} />
            </Grid>
            <Grid item container xs={10} direction="column">
                <Typography variant="body2">{title}</Typography>
                <Typography color="textSecondary">{details}</Typography>
            </Grid>
        </Grid>
    );
};


const SubscriptionPay = () => {
    let history = useHistory();
    const classes=useStyle();
    const user = useSelector((state: RootState) => state?.user);
    const [employers, setEmployers] = useState([]);
    const [isRequestFinish, setIsRequestFinish] = useState(false);
    const [employer, setEmployer] = useState(null);

    useEffect(() => {
        window.scrollTo(0,0);
        api_getEmployers()
            .then((employers)=> {
                setEmployers(employers);
            });
    }, []);

    return(
        <Container className={classes.containerRoot} maxWidth="md">
            <Card className={classes.cardRoot}>
                <Container className={classes.body} disableGutters={true}>
                    <Grid container spacing={2}>
                        <Grid item container xs={12} alignItems="center" justify="center">
                            <Grid item xs={12}>
                                <Typography variant="h2" align="center" style={{fontSize: 42, paddingBottom: 25}}>
                                    Your Exclusive Virtual Vet Package
                                </Typography>
                            </Grid>
                            <Grid item container xs={8} alignItems="center" justify="center" style={{borderTop: `10px solid ${colorError}`}}>
                                <Grid item xs={6}>
                                    <Typography variant="h6" style={{backgroundColor: colorError, color: "#fff", paddingBottom: 5}} align="center">
                                        $119 one-time cost yearly
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} style={{paddingTop: 30}}>
                            <PawCard
                                title="Unlimited Appointments"
                                details="Access expert advice with licensed veterinarians for an entire year."
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <PawCard
                                title="15% Off Prescription Visits"
                                details="Save 15% on visits that include vet prescribed medication, where available*"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <PawCard
                                title="Flexible Scheduling"
                                details="Request an appointment ASAP or schedule for a future date"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <PawCard
                                title="Real-time Answers via Video or Chat"
                                details="Connect however you feel most comfortable- whether you prefer live video or text-based chat, you can access veterinary care on our website or mobile app."
                            />
                        </Grid>
                        {!!employers?.length
                        &&
                        <Grid item xs={12}>
                            <PawCard
                                title="Please select your employer"
                                details={<Autocomplete
                                    value={employer}
                                    onChange={(event, value) => {
                                        setEmployer(value);
                                    }}
                                    options={employers}
                                    getOptionLabel={(option) => option.name}
                                    style={{width: "100%"}}
                                    renderInput={(params) => <TextField {...params} variant="outlined"/>}
                                />}
                            />
                        </Grid>}
                        <Grid item xs={12}>
                            <PaymentForm
                                employer={employer}
                                price={119.00}
                                purchaseType="subscription"
                                disabled={isRequestFinish}
                                hasSubscription={true}
                                setIsRequestFinish={setIsRequestFinish}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="caption">* Available in NJ, NY, MI, OK, VA based on state regulations</Typography>
                        </Grid>
                    </Grid>
                </Container>
            </Card>
        </Container>
    );
};

export default SubscriptionPay;
